import React from 'react';
import { Box, Typography } from '@mui/material';
import { getTextColor } from '../../../../utils/colorUtils';

/**
 * Month legend item component that shows a single item in the month legend
 * 
 * @param {Object} props
 * @param {Object} props.item - Item to display
 * @param {Date} props.date - Date for the item
 * @param {Object} props.contentTypeColors - Map of content types to colors
 * @returns {JSX.Element}
 */

const MonthLegendItem = ({ item, date, contentTypeColors }) => {
    // Get the background color for this item
    const backgroundColor = contentTypeColors[item.contentType] || '#999';
    
    // Determine text color based on background color
    const textColor = getTextColor(backgroundColor);
    
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{
                width: '20px',
                height: '20px',
                borderRadius: '4px',
                backgroundColor: backgroundColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Typography variant="caption" color={textColor} fontWeight="bold">
                    {date.getDate()}
                </Typography>
            </Box>
            <Typography variant="body2" noWrap sx={{ maxWidth: '200px' }}>
                {item.contentId}
            </Typography>
        </Box>
    );
};

export default React.memo(MonthLegendItem);